import React from 'react'

const Form = () => (
  <form className='flex form' name='Contact Form' method='POST' data-netlify='true'>
    <input type='hidden' name='form-name' value='Contact Form' />
    <div className='label-group'>
      <label htmlFor='email'>
        <input
          id='email'
          type='email'
          name='email'
          pattern='[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$'
          required
          className='bg-dark text-white placeholder-gray-500 border-2 border-white text-md py-2 px-3'
          placeholder='Type your email...'
        />
      </label>
    </div>
    <button
      className='border-2 border-white bg-white text-sm font-bold py-2 px-4 border-l-0'
      type='submit'
    >
      Join the waitlist
    </button>
  </form>
)

export default Form
